import Facebook from './Facebook'
import axios from 'axios'

export default class Audiences extends Facebook {
  constructor (user, parameters = null) {
    super(user)
    this.user = user
    this.parameters = parameters
  }
  fetchCustomAudiences () {
    const account = this.connection().account
    const fields = [
      'id', 'name', 'time_created', 'time_updated', 'time_content_updated',
      'description', 'pixel_id', 'delivery_status', 'approximate_count'
    ]
    return account.getCustomAudiences(fields)
  }
  fetchSavedAudiences () {
    const account = this.connection().account
    const fields = [
      'id', 'name', 'time_created', 'time_updated',
      'description', 'pixel_id', 'delivery_status', 'approximate_count'
    ]
    return account.getSavedAudiences(fields)
  }
  createCustomAudience () {
    const account = this.connection().account
    return account.createCustomAudience([], {
      name: this.parameters.audience.meta.name,
      subtype: 'CUSTOM',
      description: this.parameters.audience.meta.description,
      customer_file_source: 'USER_PROVIDED_ONLY'
    })
      .then(res => {
        const id = res.id
        const CustomAudience = this.SdkClass().CustomAudience
        const audience = new CustomAudience(id)
        return audience.createUser([], {payload: this.parameters.audience.payload})
          .then(res => {
            return res
          })
      })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  deleteAudience () {
    return axios({
      method: 'DELETE',
      url: `${this.parameters.id}`,
      params: {
        access_token: this.user.token
      }
    })
      .then(res => res)
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
}
